import React from "react";

const Undo = ({ customComponent, onClick, isActive, isDisabled }) => {
	const doUndo = () => {
		if (onClick) onClick();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={doUndo}
				title="Undo"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-undo" />}
			</button>
		</>
	);
};

export default Undo;
